var _templateObject;

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import { Box } from '@creditas-ui/layout';
import { styled } from '@creditas-ui/system';
import { getTypography } from '@creditas-ui/utilities';
var EmojiElement = styled(Box.withComponent('span', process.env.NODE_ENV === "production" ? {
  target: "ehjqzry0"
} : {
  target: "ehjqzry0",
  label: "EmojiElement"
}))(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", "\n  height: 32px;\n  width: 32px;\n  text-align: center;\n"])), getTypography('headingSmRegular'));
export { EmojiElement };
//# sourceMappingURL=Emoji.styles.js.map